import { pick } from "ramda"

import { httpRequest, endpoint } from "@cirrus/core/http"

export const GET = ({ page, pageSize }) =>
  httpRequest.get(
    endpoint.withRoot(`/api/v1/author/settings/webhooks?page=${page}&pageSize=${pageSize}`),
  )

export const POST = (payload) =>
  httpRequest.post(
    endpoint.withRoot("/api/v1/author/settings/webhooks"),
    pick(
      ["isActive", "title", "url", "contentType", "authType", "userName", "secretKey", "events"],
      payload,
    ),
  )

export const availablePlaceholdersGET = () =>
  httpRequest.get(endpoint.withRoot("/api/v1/author/settings/webhooks/available-placeholders"))

export const defaultTemplatesGET = () =>
  httpRequest.get(endpoint.withRoot("/api/v1/author/settings/webhooks/default-templates"))

export const itemGET = (id) =>
  httpRequest.get(endpoint.withRoot(`/api/v1/author/settings/webhooks/${id}`))

export const itemPATCH = (id, payload) =>
  httpRequest.patch(
    endpoint.withRoot(`/api/v1/author/settings/webhooks/${id}`),
    pick(
      ["isActive", "title", "url", "contentType", "authType", "userName", "secretKey", "events"],
      payload,
    ),
  )

export const massActionDELETE = (id) =>
  httpRequest.delete(endpoint.withRoot("/api/v1/author/settings/webhooks/mass-action"), {
    data: JSON.stringify(id),
    headers: { "Content-Type": "application/json" },
  })
